import axios from 'axios';
//axios.defaults.headers.common['Accept-Encoding'] = 'gzip'
var api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});
export default api;
